import { client } from "./client";

export const fetchHomeSlides = async () => {
    const response = await client.get("/api/homepage/slides/", { _skipAuth: true });
    return response.data;
};
